<template>
    <div class="print-actions-buttons">
        <div class="buttons">
            <ui5-button
                v-if="workstation && workstation.canPrintIdentificationLabel"
                :disabled="!product"
                class="finish-count-down"
                @click="$emit('print-identification-label')"
            >
                {{ trans('pages.workpost_scan_product.print_identification_label') }}
            </ui5-button>
            <ui5-button
                v-if="workstation && workstation.canPrintPrSticker"
                :disabled="!product"
                class="finish-count-down"
                @click="$emit('print-pr-sticker')"
            >
                {{ trans('pages.workpost_scan_product.print_pr_sticker') }}
            </ui5-button>
        </div>
    </div>
</template>
<script>
import localization from '../../mixins/localization';

export default {
    mixins: [localization],
    props: {
        workstation: {
            required: false,
            type: Object,
            default: null,
        },
        product: {
            required: false,
            type: Object,
            default: null,
        },
    },
};
</script>
